"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constant = require("../../constant");

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Redirect = {
  // 首页
  home: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(1);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(1);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(1);
    }
  }],
  webview: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(_ref) {
      var url = _ref.url;

      return this.invoke(2, {
        url: url
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(_ref2) {
      var url = _ref2.url;

      return this.invoke(2, {
        url: url
      });
    }
  }, {
    handler: function handler(_ref3) {
      var url = _ref3.url;

      return this.redirectToH5(2, {
        url: url
      });
    }
  }],
  // 扫一扫页面
  qrcode: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(3);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(3);
    }
  }],
  // 搜索页面
  search: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(4, {
        txt: option.keyword
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(4, {
        txt: option.keyword
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(4, {
        txt: option.keyword
      });
    }
  }],
  //充值页面 type 类型
  "top-up": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(5, {
        businessId: option.type
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(5, {
        businessId: option.type
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(5, {
        businessId: option.type
      });
    }
  }],
  // 一级品类详细
  category: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(6, {
        businessId: option.categoryId
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(6, {
        businessId: option.categoryId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(6, {
        businessId: option.categoryId
      });
    }
  }],
  // 商品详情
  product: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(7, {
        businessId: option.productId,
        param: option.productType
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(7, {
        businessId: option.productId,
        param: option.productType
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(7, {
        businessId: option.productId,
        param: option.productType
      });
    }
  }],
  // 专题页面
  topic: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(8, {
        businessId: option.topicId
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(8, {
        businessId: option.topicId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(8, {
        businessId: option.topicId
      });
    }
  }],
  // 个人中心
  center: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(9);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(9);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(9);
    }
  }],
  // 用户详情
  me: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(10);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(10);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(10);
    }
  }],
  // 收货地址列表
  addresses: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(11);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(11);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(11);
    }
  }],
  // 礼品卡列表
  cards: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(12);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(12);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(12);
    }
  }],
  // 购物车
  cart: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(13);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(13);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(13);
    }
  }],
  // 订单列表
  orders: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(14);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(14);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(14);
    }
  }],
  // 礼品卡详情
  card: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(16, {
        businessId: option.businessId,
        param: option.param
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(16, {
        businessId: option.businessId,
        param: option.param
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(16, {
        businessId: option.businessId,
        param: option.param
      });
    }
  }],
  // 电影频道
  movie: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(17);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(17);
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(17);
    }
  }],
  // 电影 影片详情
  "movie-film": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.7"],
      "ANDROID|MZMall": ["gte", "1.0.8"]
    },
    handler: function handler(option) {
      return this.invoke(22, {
        businessId: option.filmId
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(22, {
        businessId: option.filmId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(22, {
        businessId: option.filmId
      });
    }
  }],
  // 电影 影院影片排期
  "movie-cinema-film": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.7"],
      "ANDROID|MZMall": ["gte", "1.0.8"]
    },
    handler: function handler(option) {
      return this.invoke(23, {
        businessId: option.cinemaId
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(23, {
        businessId: option.cinemaId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(23, {
        businessId: option.cinemaId
      });
    }
  }],

  "groupon-detail": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.7"],
      "ANDROID|MZMall": ["gte", "1.0.8"]
    },
    handler: function handler(option) {
      return this.invoke(24, {
        businessId: option.activeId
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(24, {
        businessId: option.activeId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(24, {
        businessId: option.activeId
      });
    }
  }],

  "groupon-list": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.7"],
      "ANDROID|MZMall": ["gte", "1.0.8"]
    },
    handler: function handler() {
      return this.invoke(25);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(25);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(25);
    }
  }],

  // 卡适用影院
  "suitable-cinema": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"],
      "IOS|MZFilm": ["lt", "5.0.0"],
      "ANDROID|MZFilm": ["lt", "5.0.0"]
    },
    handler: function handler(data) {
      return this.invoke(34, {
        businessId: data.operationCode,
        childId: data.cardType,
        param: data.param,
        txt: data.cardDisplayType
      });
    }
  }],
  // 登录
  login: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(102).then(function (data) {
        return Promise.resolve(data);
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["lt", "5.0.0"],
      "ANDROID|MZFilm": ["lt", "5.0.0"]
    },
    handler: function handler() {
      return this.invoke(102).then(function (data) {
        return Promise.resolve(data);
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "5.0.0"],
      "ANDROID|MZFilm": ["gte", "5.0.0"]
    },
    handler: function handler() {
      return this.invoke(110).then(function (data) {
        return Promise.resolve(data);
      });
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(102);
    }
  }],
  // 卖座登陆
  "mz-login": [{
    pattern: {
      "IOS|MZFilm": ["gte", "5.0.0"],
      "ANDROID|MZFilm": ["gte", "5.0.0"]
    },
    handler: function handler() {
      return this.invoke(102).then(function (data) {
        return Promise.resolve(data);
      });
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(102);
    }
  }],
  //在卖座中登陆苏打
  "mz-login-sdyx": [{
    pattern: {
      "IOS|MZFilm": ["gte", "5.0.0"],
      "ANDROID|MZFilm": ["gte", "5.0.0"]
    },
    handler: function handler() {
      return this.invoke(110).then(function (data) {
        return Promise.resolve(data);
      });
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(102);
    }
  }],
  // 跳转电影订单确认页面
  "preorder-movie": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(103, {
        businessId: option.orderId
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(103, {
        businessId: option.orderId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(103, {
        businessId: option.orderId
      });
    }
  }],
  // 关闭webview
  close: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(104);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(104);
    }
  }],
  // 通知领取现金券成功，并关闭webview
  "act-noti": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.7"],
      "ANDROID|MZMall": ["gte", "1.0.8"]
    },
    handler: function handler(option) {
      return this.invoke(105, {
        businessId: option.businessId
      });
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(105, {
        businessId: option.businessId
      });
    }
  }],
  // 调用APP支付
  "to-pay": [{
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"],
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(108, {
        payType: option.payType,
        appId: option.appId,
        partnerId: option.partnerId,
        prepayId: option.prepayId,
        nonceStr: option.nonceStr,
        packageValue: option.packageValue,
        paySign: option.paySign,
        timeStamp: option.timeStamp
      });
    }
  }], //调用app支付结果页
  "to-pay-result": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(111, {
        businessId: option.payOrderId,
        childId: option.payType
      });
    }
  }],
  "change-phone-callback": [{
    // 修改手机号回调app
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(112, {
        businessId: option.mobile
      });
    }
  }],
  // 本地化首页
  "zone-home": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(40, {
        businessId: option.categoryId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(40, {
        businessId: option.categoryId
      });
    }
  }],
  // 本地化二级页
  "zone-filter": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(41, {
        businessId: option.categoryId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(41, {
        businessId: option.categoryId
      });
    }
  }],
  // 全球购页
  "global-shopping": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(29, {
        businessId: option.categoryId
      });
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(29, {
        businessId: option.categoryId
      });
    }
  }],
  // 人气优选
  recommend: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(28);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(28);
    }
  }, {
    handler: function handler() {
      return this.redirectToH5(28);
    }
  }],
  "movie-audience": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(113, option); // option : [{infoId:1, idType: 1, name: '张三'， identityNo: '42*********'}] // idType: 证件类型
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(113, option); // // option : [{infoId:1, idType: 1, name: '张三'， identityNo: '42*********'}]
    }
  }],
  // 自助服务-订单列表
  "self-service-order": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(57, option);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(57, option);
    }
  }, {
    handler: function handler(option) {
      return this.redirectToH5(57, option); // option: {businessId: '1'}
    }
  }],
  // 售后状态更新回调
  "after-sale-callback": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(114, option); // option: {businessId: orderId}
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler(option) {
      return this.invoke(114, option);
    }
  }],
  // 登出
  logout: [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(115);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(115);
    }
  }],
  "customer-service": [{
    pattern: {
      "IOS|MZMall": ["gte", "1.0.0"],
      "ANDROID|MZMall": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(116);
    }
  }, {
    pattern: {
      "IOS|MZFilm": ["gte", "1.0.0"],
      "ANDROID|MZFilm": ["gte", "1.0.0"]
    },
    handler: function handler() {
      return this.invoke(116);
    }
  }]
};

exports.default = Redirect;